import { render, staticRenderFns } from "./InvoiceIndex.vue?vue&type=template&id=0cff861d&scoped=true"
import script from "./InvoiceIndex.vue?vue&type=script&lang=js"
export * from "./InvoiceIndex.vue?vue&type=script&lang=js"
import style0 from "./InvoiceIndex.vue?vue&type=style&index=0&id=0cff861d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cff861d",
  null
  
)

export default component.exports